import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconList.tsx
const IconList = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ jsx("path", {
		fill: "currentColor",
		d: "M8 4h13v2H8zM4.5 6.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m0 7a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m0 6.9a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3M8 11h13v2H8zm0 7h13v2H8z"
	})]
});
var IconList_default = forwardRef(IconList);
//#endregion
export { IconList_default as default };
